import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import { getTranslateByKey } from "@/main/services/utils";

import * as S from "./styles";

function CanceledBySupplierWarning() {
	const warningText = getTranslateByKey("information.isCancelatedBySupplier");

	return (
		<TooltipComponent title={warningText}>
			<S.WarningText className="canceled-by-supplier-warning">{warningText}</S.WarningText>
		</TooltipComponent>
	);
}

export default CanceledBySupplierWarning;
